module.exports = __webpack_public_path__ + "img/logo-icon.fa7237bb.png";